import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom';
import { PrivateRoute } from 'components/common/routes';
import Version from 'components/VersionInfo';
import useUser from 'hooks/useUser';
import { getCurrentUserAction } from 'store/actions/user';
import LoginContainer from 'components/Login';
import ForgotPasswordContainer from 'components/ForgotPassword';
import SetNewPasswordContainer from 'components/SetNewPassword';
import TableViewContainer from 'components/TableViewContainer';
import ErrorPageContainer from 'components/common/ErrorPage';

function AppLayout() {
  const dispatch = useDispatch();
  const { isAuthenticated } = useUser();

  useEffect(() => {
    dispatch(getCurrentUserAction({}));
  }, [dispatch, isAuthenticated]);

  return (
    <div className="App">
      <Router>
        <Switch>
          <Route exact path="/login" component={LoginContainer} />
          <Route exact path="/forgot-password" component={ForgotPasswordContainer} />
          <Route path="/reset-password" component={SetNewPasswordContainer} />
          <Route exact path="/version" component={Version} />
          <PrivateRoute exact path="/" component={TableViewContainer} />
          <PrivateRoute path="/inventory" component={TableViewContainer} />
          <PrivateRoute path="/orders" component={TableViewContainer} />
          <Route
            path="/forbidden"
            render={(props) => (
              <ErrorPageContainer
                {...props}
                statusCode="403"
                statusMessage="Access Denied"
                statusDescription="Sorry, but you do not have permission to access this page."
              />
            )}
          />
          <Route
            render={(props) => (
              <ErrorPageContainer
                {...props}
                statusCode="404"
                statusMessage="Page not found"
                statusDescription="The page is missing or you assembled the link incorrectly."
              />
            )}
          />
        </Switch>
      </Router>
    </div>
  );
}

export default AppLayout;
